export enum MppViewModes {
  DAYS = 0,
  MONTHS = 1,
  YEARS = 2,
}
